/**
 * useViewportSize Hook
 * Custom hook for tracking viewport size and calculating responsive scales
 */

import { useState, useEffect } from 'react';

export const useViewportSize = () => {
  const [viewportSize, setViewportSize] = useState({ width: 0, height: 0 });

  // Track viewport size for dynamic scaling
  useEffect(() => {
    const updateViewportSize = () => {
      setViewportSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    updateViewportSize();
    window.addEventListener('resize', updateViewportSize);

    return () => window.removeEventListener('resize', updateViewportSize);
  }, []);

  // Calculate dynamic logo scale based on viewport
  const getLogoScale = () => {
    if (viewportSize.width < 480) return 2.8;
    if (viewportSize.width < 768) return 2.2;
    if (viewportSize.width < 1024) return 1.5;
    return 1;
  };

  return {
    viewportSize,
    getLogoScale,
  };
};

export default useViewportSize;
